import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  error: false,
  data: null,
  product: null,
};

// Slice
const productDetailSlice = createSlice({
  name: "productDetail",
  initialState,
  reducers: {
    getProductDetail(state) {
      return { ...state, loading: true, error: false };
    },
    setProductDetail(state, action) {
      const { product } = action.payload;
      return {
        ...state,
        product,
      };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  getProductDetail,
  setProductDetail,
  fetchDataSuccess,
  fetchDataFailure,
} = productDetailSlice.actions;

export default productDetailSlice.reducer;

const asis = {
  store_id: "1096",
  item_id: "8859458102826",
  sku_nm: "마하차녹  구미망고젤리 300g",
  stock_status: "IN_STOCK",
  stock_amt: 47,
  original_price: 6980,
  price: 6980,
  enuri: 0,
  enuri_dt: "",
  event_title: [],
  event_info: [],
  event_price: null,
  event_dt: "",
  type: "IN_STOCK",
  cause: "",
  mark_unit_nm: "",
  prdt_ven_nm: "",
  gcode: "1342",
  mcode: "10161",
  dcode: "100010",
  gcode_nm: "",
  mcode_nm: "",
  dcode_nm: "",
  sell_price: 6980,
  discounted_price: null,
  flyer: null,
  ir_masking_text: null,
  price_masking_text: null,
  image_type: "ssg",
};

const withEvent = {
  data: [
    {
      sku_code: "12345",
      sku_nm: "바나나",
      sell_price: "600",
      discounted_price: "540",
      discounted_rate: "10",
      ven_nm: "",
      mark_unit_nm: "",
      event: [
        {
          event_title: "상품권 할인",
          event_start_date: "20240426",
          event_end_date: "20240502",
          event_type: "promotion",
          event_desc: "신세계상품권 3만원 증정",
          tag: "상품권 할인",
        },
        {
          event_title: "가격 할인",
          event_start_date: "20240426",
          event_end_date: "20240502",
          event_type: "promotion",
          event_desc: "행사기간 4.5(금) ~ 4.12(목)",
          tag: "상품권 할인",
        },
      ],
      stock_qty: 250,
      stock_status: "IN_STOCK",
    },
  ],
};

const withoutEvent = {
  data: [
    {
      sku_code: "12345",
      sku_nm: "바나나",
      sell_price: "600",
      discounted_price: "",
      ven_nm: "",
      mark_unit_nm: "",
      event: null,
      stock_qty: 240,
      stock_status: "IN_STOCK",
    },
  ],
};

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });

    const response = yield call(apiService.get, apiUrl);
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const product = response.data.data[0];
      yield put(setProductDetail({ product }));
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* productDetailSaga() {
  yield takeLatest(getProductDetail.type, fetchDataSaga);
}
